export interface MemberInterface {
  id: number;
  person_id: number;
  properties?: Record<string, any> | null;
  consents?: Record<string, null | { status: any }> | null;
  sms_status: string;
  email_status: string;
  push_status: string;
  created_at: string;
  updated_at: string;
  banned_until?: string | null;
}

export enum IdentifierType {
  MSISDN = 'msisdn',
  EMAIL = 'email',
}

export interface MemberIdentifier {
  identifier: string;
  identifier_type: IdentifierType;
}
